import './front.scss';
import { CustomHtmlFront } from './CustomHtmlFront.js';

new CustomHtmlFront( document ).init();
